export default {
  'reports.title': 'Manage Reports',
  'reports.reportGroups': 'Report Groups',
  'reports.permissions.description': 'Add or remove who can access the report {name}.',
  'reports.form.reportGroup': 'Report Group',
  'reports.form.provider': 'Provider',
  'reports.form.reportId': 'PowerBI Report Id',
  'reports.form.datasetId': 'PowerBI Dataset Id',
  'reports.form.workspaceId': 'Power BI Workspace Id',
  'reports.form.defaultReportSection': 'Default Report Section',
  'reports.form.isMultipage': 'Multiple Pages?',
  'reports.form.isReportDataFilterByUserEnabled': 'Report Data Filter by User?',
  'reports.form.isReportDataFilterByPositionEnabled': 'Report Data Filter by Position?',
  'reports.form.reportDataFilterUserTableName': 'Table Name for User Filter',
  'reports.form.reportDataFilterUserFieldName': 'Field Name for User Filter',
  'reports.form.reportDataFilterUserFieldNameInternal': 'Internal Field Name for User Filter',
  'reports.form.reportDataFilterPositionTableName': 'Table Name for Position Filter',
  'reports.form.reportDataFilterPositionFieldName': 'Field Name for Position Filter',
  'reports.form.reportDataFilterPositionFieldNameInternal':
    'Internal Field Name for Position Filter',
  'reports.form.isReportDataFilterByAreaEnabled': 'Report Data Filter by Area?',
  'reports.form.reportDataFilterAreaTableName': 'Table Name for Area Filter',
  'reports.form.reportDataFilterAreaFieldName': 'Field Name for Area Filter',
  'reports.form.reportDataFilterAreaFieldNameInternal': 'Internal Field Name for Area Filter',
  'reports.form.isReportDataFilterByDynamicEntityEnabled': 'Report Data Filter by Dynamic Entity?',
  'reports.form.reportDataFilterDynamicEntityTableName': 'Table Name for Dynamic Entity Filter',
  'reports.form.reportDataFilterDynamicEntityFieldName': 'Field Name for Dynamic Entity Filter',
  'reports.form.reportDataFilterDynamicEntityId': 'Dynamic Entity',
  'reports.form.reportDataFilterDynamicEntityFieldUserFieldId': 'Dynamic Entity / User Field',
  'reports.form.reportDataFilterDynamicEntityFieldDataFieldId': 'Dynamic Entity / Filter Field',
  'reports.form.isReportDataFilterByUserGroupsEnabled': 'Report Data Filter by User Groups?',
  'reports.form.reportDataFilterUserGroupTableName': 'Table Name for User Group Filter',
  'reports.form.reportDataFilterUserGroupFieldName': 'Field Name for User Group Filter',
  'reports.form.reportDataFilterUserGroupFieldNameInternal':
    'Internal Field Name for User Group Filter',
  'reports.type.administration': 'Administration',
  'reports.type.process': 'Process',
  'reports.type.request': 'Request',
  'reports.type.generic': 'Generic',
  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Mobile',
  'reports.platform.webMobile': 'Web and Mobile',
  'reports.provider.native': 'Native',
  'reports.provider.powerbi': 'Power BI',
  'reports.logicalOperator.or': 'Or',
  'reports.logicalOperator.and': 'And',
  'reports.form.provider': 'Engine',
  'reports.provider.native': 'Native',
  'reports.provider.powerbi': 'Power BI',
  'reports.form.owner': 'Owner',
  'reports.form.processId': 'Process',
  'reports.form.powerBIServerConfigurationId': 'Power BI server',
  'reports.form.accessControl.users': 'Users',
  'reports.form.accessControl.userGroups': 'User groups',
  'reports.form.accessControl.positions': 'Positions',
  'reports.form.accessControl.areas': 'Areas',
  'reports.form.accessControl.filtersLogicalOperator': 'Access control operator',
  'reports.form.accessControl.userGroupsFiltersLogicalOperator':
    'Operator between groups, positions and areas',
  'reports.form.accessControl.operator.and': 'AND (All conditions)',
  'reports.form.accessControl.operator.or': 'OR (Any condition)',
  'reports.form.isReportDataFilterByUserCompanyEnabled': 'Report Data Filter by Company?',
  'reports.form.reportDataFilterUserCompanyTableName': 'Table Name for Company Filter',
  'reports.form.reportDataFilterUserCompanyFieldName': 'Field Name for Company Filter',
  'reports.form.reportDataFilterUserCompanyFieldNameInternal':
    'Internal Field Name for Company Filter',
  'reports.form.isReportDataFilterByUserEnvironmentEnabled': 'Report Data Filter by Environment?',
  'reports.form.reportDataFilterUserEnvironmentTableName': 'Table Name for Environment Filter',
  'reports.form.reportDataFilterUserEnvironmentFieldName': 'Field Name for Environment Filter',
  'reports.form.reportDataFilterUserEnvironmentFieldNameInternal':
    'Internal Field Name for Environment Filter',
  'reports.builder.title': 'Report Builder',
  'reports.builder.error.notFound': 'The report does not exist or was not found',
  'reports.builder.session.error':
    'A writing session could not be opened. You can edit the report in the form and retry later.',
  'reports.builder.create.error': 'Could not create the report',
  'reports.builder.new.title': 'New report',
  'reports.builder.new.continue': 'Continue',
  'reports.builder.publish.success': 'Report published',
  'reports.builder.publish.error': 'Could not publish the report',
  'reports.builder.setCurrent': 'Set as current',
  'reports.builder.setCurrent.success': 'Version set as current successfully',
  'reports.builder.setCurrent.error': 'Error setting version as current',
  'reports.builder.publish.codeRequired':
    'Publishing requires code.js with content or a document URL.',
  'reports.builder.version.error': 'Could not switch version',
  'reports.builder.unsaved.confirm': 'You have unsaved changes. Leave anyway?',
  'reports.builder.unsaved.indicator': 'Unsaved changes',
  'reports.builder.open': 'Open',
  'reports.builder.notPublished': 'This report is not published yet',
  'reports.builder.notPublished.description': 'Publish a version so users can open it.',
  'reports.builder.section.identity': 'Basic information',
  'reports.builder.section.accessControl': 'Access control',
  'reports.builder.accessControl.legend': 'Who can open the report.',
  'reports.builder.section.datasets': 'Datasets',
  'reports.builder.section.queries': 'Queries',
  'reports.builder.section.filters': 'Filters',
  'reports.builder.section.parameters': 'Parameters',
  'reports.builder.section.code': 'Code',
  'reports.builder.code': 'Code',
  'reports.builder.code.empty': 'This draft has no code.js or code.css yet.',
  'reports.builder.code.emptyFile': 'This file has no content.',
  'reports.builder.section.settings': 'Settings',
  'reports.builder.elements.code.html': 'HTML',
  'reports.builder.elements.code.js': 'JavaScript',
  'reports.builder.elements.code.css': 'CSS',
  'reports.builder.elements.code.save': 'Save code',
  'reports.builder.elements.code.attachmentHint':
    'This file is stored as an attachment. Saving replaces it with the text in this panel.',
  'reports.builder.elements.settings.json': 'Settings (JSON)',
  'reports.builder.elements.settings.save': 'Save settings',
  'reports.builder.elements.settings.invalid': 'Settings JSON is not valid.',
  'reports.builder.elements.settings.legend':
    'Reserved ConfigNativeReport.settings object. Do not invent fields: title, folder and owner live in Basic information. Access control is a separate drawer.',
  'reports.builder.identity.legend':
    'Report identity (parent). Saved with PUT /report — not a builder element and not Publish.',
  'reports.builder.identity.save': 'Save',
  'reports.builder.elements.save.success': 'Changes were sent to the version.',
  'reports.builder.elements.save.error': 'The element could not be saved.',
  'reports.builder.elements.datasetKey': 'Dataset key',
  'reports.builder.elements.datasetKey.legend':
    'Use the catalog. Process-runtime keys require processIds; users, positions, areas, user-groups, user-group-users, processes, process-groups and dynamic-entity omit them.',
  'reports.builder.elements.catalogRef': 'Dataset',
  'reports.builder.elements.catalogRef.legend':
    'Pick one catalog dataset. For form-data or an entity, choose the source and the key is built for you.',
  'reports.builder.dataset.add': 'Add dataset',
  'reports.builder.dataset.addHint': 'Pick the source and, if needed, the process or entity.',
  'reports.builder.dataset.configured': 'Added',
  'reports.builder.dataset.empty': 'This report has no datasets yet.',
  'reports.builder.dataset.close': 'Close',
  'reports.builder.dataset.cancelEdit': 'Cancel',
  'reports.builder.dataset.previewKey': 'Key',
  'reports.builder.dataset.changeHint': 'Saving will change the key from {from} to {to}.',
  'reports.builder.dataset.duplicate': 'That dataset is already on the report.',
  'reports.builder.dataset.removeConfirm': 'Remove this dataset from the report?',
  'reports.builder.dataset.inUse':
    'Remove the queries that use this dataset first ({query}).',
  'reports.builder.dataset.fields': 'Fields',
  'reports.builder.dataset.table.field': 'Field',
  'reports.builder.dataset.table.type': 'Type',
  'reports.builder.dataset.table.relation': 'Relation',
  'reports.builder.dataset.table.processCount':
    '{count, plural, one {# process} other {# processes}}',
  'reports.builder.dataset.table.fieldCount': '{count, plural, one {# field} other {# fields}}',
  'reports.builder.dataset.table.noFields': 'No fields resolved yet',
  'reports.builder.dataset.fieldType.guid': 'GUID',
  'reports.builder.dataset.fieldType.text': 'Text',
  'reports.builder.dataset.fieldType.number': 'Number',
  'reports.builder.dataset.fieldType.boolean': 'Boolean',
  'reports.builder.dataset.fieldType.date': 'Date',
  'reports.builder.dataset.fieldType.datetime': 'Date and time',
  'reports.builder.dataset.fieldType.user': 'User',
  'reports.builder.dataset.fieldType.reference': 'Reference',
  'reports.builder.dataset.fieldType.position': 'Position',
  'reports.builder.dataset.fieldType.area': 'Area',
  'reports.builder.dataset.fieldType.user-group': 'User group',
  'reports.builder.catalog.kind.static': 'Static',
  'reports.builder.catalog.kind.processFormData': 'Form data',
  'reports.builder.catalog.kind.dynamicEntity': 'Dynamic entity',
  'reports.builder.elements.catalog.loading': 'Loading dataset catalog…',
  'reports.builder.elements.catalog.incompleteKey':
    'Pick the process and form, or the entity, to build the dataset key.',
  'reports.builder.elements.templateProcessId': 'Form process',
  'reports.builder.elements.templateFormId': 'Form',
  'reports.builder.elements.templateEntityId': 'Dynamic entity',
  'reports.builder.elements.processIds': 'Dataset processes',
  'reports.builder.elements.processIds.legend':
    'Required for process-runtime keys (process-instances and similar). Omit it for process-form-data, users, positions, areas, user-groups, user-group-users, processes, process-groups and dynamic-entity.',
  'reports.builder.elements.processIds.required':
    'This dataset requires at least one process.',
  'reports.builder.elements.filterKey': 'Identifier',
  'reports.builder.elements.filterKey.legend':
    'Technical filter key. Builder metadata only; it is not executed at runtime.',
  'reports.builder.elements.filterLabel': 'Display name',
  'reports.builder.elements.filterLabel.legend':
    'Fallback if the catalog has no field label. It does not drive runtime.',
  'reports.builder.filter.dataset': 'Dataset',
  'reports.builder.elements.filterDataset.legend':
    'Pick a dataset already added to the report. Fields come from the catalog.',
  'reports.builder.filter.pickDataset': 'Choose dataset',
  'reports.builder.filter.pickDataset.empty': 'Use a dataset already on the report',
  'reports.builder.filter.pickDataset.search': 'Search report datasets…',
  'reports.builder.filter.pickDataset.none': 'No matching datasets',
  'reports.builder.elements.fieldKey': 'Field',
  'reports.builder.elements.fieldKey.legend':
    'Field type and selector metadata come from the catalog. Do not persist source on the filter.',
  'reports.builder.elements.fieldKey.relation':
    'Selector: {dataset}.{displayField}',
  'reports.builder.elements.behavior': 'Behavior',
  'reports.builder.elements.operator': 'Operator',
  'reports.builder.elements.filterValue': 'Value',
  'reports.builder.elements.filterValue.legend':
    'Use ; for lists (in / not-in) or for a range (between). Leave empty for is-null / is-not-null.',
  'reports.builder.elements.filterContextValue': 'Context value',
  'reports.builder.elements.filterContextValue.legend':
    'v1 context value is only $currentUser.',
  'reports.builder.elements.filterDefaultValue': 'Default value',
  'reports.builder.elements.filterDefaultValue.legend':
    'Only used by available filters. Same shape as value.',
  'reports.builder.filter.add': 'Add filter',
  'reports.builder.filter.addHint': 'Pick the dataset, field and how it is applied.',
  'reports.builder.filter.configured': 'Added',
  'reports.builder.filter.empty': 'This report has no filters yet.',
  'reports.builder.filter.noDatasets': 'Add a dataset before creating filters.',
  'reports.builder.filter.removeConfirm': 'Remove this filter from the report?',
  'reports.builder.filter.duplicate': 'That filter key is already on the report.',
  'reports.builder.filter.valueRequired': 'This operator requires a value.',
  'reports.builder.filter.contextValueRequired':
    'Context requires the $currentUser value.',
  'reports.builder.filter.metadata':
    'These filters are builder metadata. They are not executed. Restrict data in the query filter (queries[].filter).',
  'reports.builder.filter.details': 'Details',
  'reports.builder.filter.fieldManual':
    'The catalog did not return fields. You can type the field key.',
  'reports.builder.filter.behavior.legend':
    'Compatibility metadata. Fixed, available and context are not applied to queryKey runtime. Context only accepts $currentUser.',
  'reports.builder.filter.behavior.fixed': 'Fixed',
  'reports.builder.filter.behavior.available': 'Available',
  'reports.builder.filter.behavior.context': 'Context',
  'reports.builder.filter.operator.eq': 'Equals',
  'reports.builder.filter.operator.neq': 'Not equal',
  'reports.builder.filter.operator.in': 'In list',
  'reports.builder.filter.operator.notIn': 'Not in list',
  'reports.builder.filter.operator.gt': 'Greater than',
  'reports.builder.filter.operator.gte': 'Greater or equal',
  'reports.builder.filter.operator.lt': 'Less than',
  'reports.builder.filter.operator.lte': 'Less or equal',
  'reports.builder.filter.operator.contains': 'Contains',
  'reports.builder.filter.operator.startsWith': 'Starts with',
  'reports.builder.filter.operator.endsWith': 'Ends with',
  'reports.builder.filter.operator.between': 'Between',
  'reports.builder.filter.operator.isNull': 'Is null',
  'reports.builder.filter.operator.isNotNull': 'Is not null',
  'reports.builder.elements.parameterKey': 'Parameter key',
  'reports.builder.elements.parameterKey.legend':
    '{ key } only. Start with a letter or _; consume uses it as viewer input.',
  'reports.builder.elements.parameter.legend':
    'Untyped report-level consume parameters. They do not execute. Typed live parameters belong on each query.',
  'reports.builder.parameter.add': 'Add parameter',
  'reports.builder.parameter.addHint': 'Pick a name. People who open the report can enter the value.',
  'reports.builder.parameter.configured': 'Added',
  'reports.builder.parameter.empty': 'This report has no parameters yet.',
  'reports.builder.parameter.removeConfirm': 'Remove this parameter from the report?',
  'reports.builder.parameter.duplicate': 'That parameter key is already on the report.',
  'reports.builder.parameter.keyInvalid':
    'The key must start with a letter or _ and use only letters, numbers and _.',
  'reports.builder.query.add': 'Add query',
  'reports.builder.query.addHint': 'Pick the dataset, type and how it is grouped.',
  'reports.builder.query.configured': 'Added',
  'reports.builder.query.empty': 'This report has no queries yet.',
  'reports.builder.query.removeConfirm': 'Remove this query from the report?',
  'reports.builder.query.pickDataset': 'Choose dataset',
  'reports.builder.query.pickDataset.empty': 'Use a dataset already on the report',
  'reports.builder.query.pickDataset.legend':
    'A query can only read a dataset already added. It cannot broaden scope.',
  'reports.builder.query.pickDataset.search': 'Search report datasets…',
  'reports.builder.query.pickDataset.none': 'No matching datasets',
  'reports.builder.query.key': 'Query key',
  'reports.builder.query.key.legend':
    'Unique. Runtime uses it as queryKey: reporting.query(key, parameters).',
  'reports.builder.query.type': 'Type',
  'reports.builder.query.type.rows': 'Rows',
  'reports.builder.query.type.aggregate': 'Aggregate',
  'reports.builder.query.metrics': 'Metrics',
  'reports.builder.query.metricKey': 'Metric key',
  'reports.builder.query.metricOp': 'Operation',
  'reports.builder.query.addMetric': 'Add metric',
  'reports.builder.query.metric.count': 'Count',
  'reports.builder.query.metric.countDistinct': 'Count distinct',
  'reports.builder.query.metric.sum': 'Sum',
  'reports.builder.query.metric.average': 'Average',
  'reports.builder.query.metric.min': 'Min',
  'reports.builder.query.metric.max': 'Max',
  'reports.builder.query.dimensions': 'Dimensions',
  'reports.builder.query.dimensionKey': 'Dimension key',
  'reports.builder.query.addDimension': 'Add dimension',
  'reports.builder.query.bucket': 'Bucket',
  'reports.builder.query.bucket.day': 'Day',
  'reports.builder.query.bucket.week': 'ISO week',
  'reports.builder.query.bucket.month': 'Month',
  'reports.builder.query.bucket.quarter': 'Quarter',
  'reports.builder.query.bucket.year': 'Year',
  'reports.builder.query.select': 'Fields',
  'reports.builder.query.select.legend':
    'Catalog semantic keys only. No SQL or physical columns.',
  'reports.builder.query.filter': 'Query filter',
  'reports.builder.query.filter.legend':
    'This filter is executed. It is not the builder filters list. Use a value or a declared parameterKey.',
  'reports.builder.query.filterValue': 'Value',
  'reports.builder.query.filterParameter': 'Parameter',
  'reports.builder.query.parameters': 'Executable parameters',
  'reports.builder.query.parameterKey': 'Key',
  'reports.builder.query.parameterType': 'Type',
  'reports.builder.query.parameterRequired': 'Required',
  'reports.builder.query.optional': 'Optional',
  'reports.builder.query.required': 'Required',
  'reports.builder.query.addParameter': 'Add parameter',
  'reports.builder.query.orderField': 'Order by',
  'reports.builder.query.orderDirection': 'Direction',
  'reports.builder.query.order.asc': 'Ascending',
  'reports.builder.query.order.desc': 'Descending',
  'reports.builder.query.limit': 'Limit',
  'reports.builder.query.limit.legend':
    'Max 5000. Rows default to 1000; aggregates default to 5000.',
  'reports.builder.query.keyInvalid':
    'The key must start with a letter or _ and use only letters, numbers or _.',
  'reports.builder.query.datasetMissing': 'The query must use a dataset already on the report.',
  'reports.builder.query.duplicate': 'That query key is already on the report.',
  'reports.builder.query.selectRequired': 'A rows query needs at least one field.',
  'reports.builder.query.unknownField': 'Use catalog semantic fields only.',
  'reports.builder.query.orderFieldInvalid':
    'Order must be a selected field or a dimension/metric key.',
  'reports.builder.query.metricsRequired': 'An aggregate query needs at least one metric.',
  'reports.builder.query.outputKeyDuplicate': 'Dimension and metric keys must be unique.',
  'reports.builder.query.metricFieldRequired': 'This operation requires a field.',
  'reports.builder.query.metricTypeInvalid': 'That operation is not valid for the field type.',
  'reports.builder.query.bucketInvalid': 'Bucket is only valid on date or datetime.',
  'reports.builder.query.limitInvalid': 'Limit must be between 1 and 5000.',
  'reports.builder.query.parameterInvalid':
    'The parameter needs a valid key and an allowed type (not user or reference).',
  'reports.builder.query.parameterDuplicate': 'That parameter key is already on the query.',
  'reports.builder.query.filterParameterMissing':
    'The filter parameterKey must exist on the query parameters.',
  'reports.builder.elements.add': 'Add',
  'reports.builder.elements.save': 'Save',
  'reports.builder.elements.edit': 'Edit',
  'reports.builder.elements.remove': 'Remove',
  'reports.builder.consume.filters': 'Filters',
  'reports.builder.chat': 'Assistant',
  'reports.builder.chat.title': 'AI Assistant',
  'reports.builder.sidebar.overview': 'Overview',
  'reports.builder.preview.empty': 'Your report starts here',
  'reports.builder.preview.empty.description':
    'Describe it in the chat and the assistant will build it step by step',
  'reports.builder.preview.empty.hint': 'Type in the chat to get started',
  'reports.form.powerBiConfig.saveError':
    'The report was saved, but the Power BI configuration could not be saved. Edit it again to retry.',
};
